import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { DARK_NAVY, DARK_NAVY_LIGHT, PROFILE_FONT } from "../../constants/layout";
import { primaryButtonSx } from "../AssetListing/assetListingShared";

type HoldingsErrorDialogProps = {
  open: boolean;
  message: string | null;
  title?: string;
  onClose: () => void;
};

const HoldingsErrorDialog: React.FC<HoldingsErrorDialogProps> = ({
  open,
  message,
  title = "Unable to load holdings",
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: "16px",
        fontFamily: PROFILE_FONT,
      },
    }}
  >
    <DialogTitle
      sx={{
        fontFamily: PROFILE_FONT,
        fontWeight: 700,
        fontSize: 18,
        color: DARK_NAVY,
        pb: 1,
      }}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontFamily: PROFILE_FONT, fontSize: 14, color: DARK_NAVY_LIGHT }}>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button onClick={onClose} sx={{ ...primaryButtonSx, px: 3 }}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default HoldingsErrorDialog;
